module.exports = __webpack_public_path__ + "img/ic_humidity.c74f67c5.png";